import AuthorizedHOC from './AuthorizedHOC'
export default AuthorizedHOC


// WEBPACK FOOTER //
// ./src/modules/AuthorizedHOC/index.js